import _document from "./document.js";
var exports = {};
var Document = _document;
exports = new Document();
export default exports;